module.exports = __webpack_public_path__ + "static/img/pic_trauma.d91570c2.png";